import { render } from "./AgentsTeams.vue?vue&type=template&id=7a84cc2d&scoped=true"
import script from "./AgentsTeams.vue?vue&type=script&lang=js"
export * from "./AgentsTeams.vue?vue&type=script&lang=js"

import "./AgentsTeams.vue?vue&type=style&index=0&id=7a84cc2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a84cc2d"]])

export default __exports__